import { BASE_URL } from "@/constants/endpoints";
import { CheckRequestStatus } from "@/constants/entity-status";
import { CheckRequestDetail } from "@/pages/requests/check/schema/check-requests.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let CheckRequestsApiPromise: Promise<AxiosInstance> | null = null;

const getCheckRequestsApi = async (): Promise<AxiosInstance | null> => {
  if (CheckRequestsApiPromise) return CheckRequestsApiPromise;
  CheckRequestsApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return CheckRequestsApiPromise;
};

export interface GetCheckRequestsProps {
  fechaDesde: string;
  fechaHasta: string;
  monto: string;
  nroCuenta: string;
  idSucursal: number[];
  estado: string[];
  usuario: string;
  "P.Pagina": number;
  "P.Records": number;
}

export const getCheckRequests = async (props: GetCheckRequestsProps) => {
  const api = await getCheckRequestsApi();
  if (!api) return null;
  const response = await api.get(
    `/SolicitudCheque/GetListadoSolicitudesCheque?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface CreateCheckRequestProps {
  nroCuentaOrigen: number;
  monto: number;
  claveSucursal: string;
  mensaje: string;
  tipoSolicitud: number;
  fechaVto: string;
  usuarioCrea: string;
  idUsuarioMobile: number;
}

export interface GetCheckRequestProps {
  id: number;
  usuarioActual: string;
}

export const getCheckRequest = async (
  props: GetCheckRequestProps,
): Promise<CheckRequestDetail | null> => {
  const api = await getCheckRequestsApi();
  if (!api) return null;
  const response = await api.get(
    `/SolicitudCheque/GetDetalleSolicitudCheque?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export const createCheckRequest = async (props: CreateCheckRequestProps) => {
  const api = await getCheckRequestsApi();
  if (!api) return null;
  const response = await api.post(
    `/SolicitudCheque/CrearSolicitud?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface UpdateCheckRequestProps {
  idSolicitud: number;
  estado?: CheckRequestStatus;
  idMotivo?: number;
  monto?: number;
  mensaje?: string;
  usuarioActual?: string;
  nroCheque?: number;
}

export const updateCheckRequest = async (props: UpdateCheckRequestProps) => {
  const api = await getCheckRequestsApi();
  if (!api) return null;
  const response = await api.put(
    `/SolicitudCheque/EditarSolicitudCheque?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};
